__turbopack_context__.v({
  "avatar": "_1U520a_avatar",
  "avatarImg": "_1U520a_avatarImg",
  "avatarPlaceholder": "_1U520a_avatarPlaceholder",
  "card": "_1U520a_card",
  "content": "_1U520a_content",
  "description": "_1U520a_description",
  "details": "_1U520a_details",
  "meta": "_1U520a_meta",
  "metaDot": "_1U520a_metaDot",
  "metaIcon": "_1U520a_metaIcon",
  "subtitle": "_1U520a_subtitle",
  "tag": "_1U520a_tag",
  "tagBrand": "_1U520a_tagBrand",
  "tagDefault": "_1U520a_tagDefault",
  "tagHighValue": "_1U520a_tagHighValue",
  "tags": "_1U520a_tags",
  "title": "_1U520a_title",
});
